import './FeatureFlagsContainer.css';
import React from 'react';
import { SectionTitle } from 'Components/Titles';
import { FeatureFlagCard } from './components/FeatureFlagCard';
import featureFlags from 'Config/featureFlags.json';
import { getFeatureFlag, setFeatureFlag } from 'Utils/FeatureFlags';

export const FeatureFlagsContainer = () => {
  const handleToggle = (key) => (toggled) => {
    setFeatureFlag(key, toggled);
  };

  const renderCards = () => {
    return featureFlags.map((flag) => (
      <FeatureFlagCard
        key={flag.name}
        name={flag.name}
        description={flag.description}
        ticketLink={flag.ticket}
        handleToggle={handleToggle(flag.cookieName)}
        defaultSetting={getFeatureFlag(flag.cookieName)}
      />
    ));
  };

  return (
    <div className="debugContainer">
      <SectionTitle text="Debug Panel - Feature Flags" />
      <p className="cookieMsg">
        Feature flags toggled here are set in the cookies, so it's best to refresh the page after toggling to ensure you
        have the desired settings.
      </p>
      <div className="featureFlagCards">{renderCards()}</div>
    </div>
  );
};
